var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSun = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.25a.75.75 0 0 1 .75.75v1a.75.75 0 1 1-1.5 0V2A.75.75 0 0 1 8 1.25zm3.227 2.72a.75.75 0 0 0 1.061 1.06l.742-.742a.75.75 0 0 0-1.06-1.06l-.743.742zM5.03 5.03a.75.75 0 0 1-1.06 0l-.743-.742a.75.75 0 1 1 1.06-1.06l.743.742a.75.75 0 0 1 0 1.06zm8 8a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 0 1 1.06-1.06l1 1a.75.75 0 0 1 0 1.06zm-8-1-1 1a.75.75 0 0 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 1.06z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 4.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 13a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0v-1zm6-5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 .75.75zM3 8.75a.75.75 0 1 0 0-1.5H2a.75.75 0 1 0 0 1.5h1z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSun);
export default ForwardRef;